var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['textarea', _vm.size, _vm.color, {'invalid': _vm.invalid}]},[_c('textarea',_vm._b({domProps:{"innerHTML":_vm._s(_vm.$slots.default ? _vm.$slots.default[0].text : null)}},'textarea',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }